module.exports = __webpack_public_path__ + "img/5.095d94b1.jpg";